import '../styling/NewClientDetailsList.css';
import userimage from '../resources/user.png'
import homeimage from '../resources/home.png'
import { useParams } from 'react-router-dom';
import {useEffect, useState} from 'react';
import {useAuthContext} from "../hooks/useAuthContext"
import API_BASE_URL from '../config.js';


const NewClientDetailsList = () => {
    
    const { clientId } = useParams();

    const {user} = useAuthContext();

    const [firstName,setFirstName] = useState('');
    const [lastName,setLastName] = useState('');
    const [companyName,setCompanyName] = useState('');
    const [phoneNumber,setPhoneNumber] = useState('');
    const [email,setEmail] = useState('');
    const [street1,setStreet1] = useState('');
    const [street2,setStreet2] = useState('');
    const [city,setCity] = useState('');
    const [state,setState] = useState('');
    const [zip,setZip] = useState('');
    const [country,setCountry] = useState('');

    useEffect(() => {
        const fetchClients = async () => {
    
            const response = await fetch(`${API_BASE_URL}/api/client/${clientId}`, {
                headers: {"Authorization": `Bearer ${user.token}`}
            })
    
            const json = await response.json()
    
            if(response.ok){
                setFirstName(json.clientFirst);
                setLastName(json.clientLast);
                setCompanyName(json.clientCompany);
                console.log(json.clientCompany);
                setPhoneNumber(json.clientPhone);
                setEmail(json.clientEmail);
                setStreet1(json.clientStreet1);
                setStreet2(json.clientStreet2);
                setCity(json.clientCity);
                setState(json.clientState);
                setZip(json.clientZip);
                setCountry(json.clientCountry);
            }     
        }
        if (user){
            fetchClients()
        }  

      }, [])

    return ( 
        <div className="newcreateclientformcontainer2">
            <div className="newformleft">
                <div className="newclientitle">
                <div className="newformleftcircle">
                <img src={userimage} alt="" />
                </div>
                <h1 className="text-3xl font-bold ml-4">Client Details</h1> 
                </div>
                <div className="newformnames2">
                {firstName ? <h1><b>First Name:</b>{firstName}</h1>: <h1><b>First Name:</b>N/A</h1>}
                {lastName ? <h1 id="n2"><b>Last Name:</b>{lastName}</h1> : <h1 id="n2"><b>Last Name:</b>N/A</h1> }    
                </div>
                {companyName ? <h1><b>Company Name:</b>{companyName}</h1> : <h1><b>Company Name:</b>N/A</h1> }
                
                <h1 className='text-1xl font-bold' id="nfcd2">Contact Details</h1>
                {phoneNumber ? <h1><b>Phone Number:</b> {phoneNumber}</h1> : <h1><b>Phone Number:</b> N/A</h1> }
                {email ? <h1><b>Email:</b> {email}</h1> : <h1><b>Email:</b> N/A</h1> }
            </div>
            <div className="newformright">
                <div className="newclientproperty">
                <div className="newformleftcircle">
                <img src={homeimage} alt="" />
                </div>
                <h1 className="text-3xl font-bold ml-4">Property Details</h1> 
                </div>
                {street1 ? <h1><b>Street1:</b> {street1}</h1>  : <h1><b>Street1:</b> N/A</h1> }
                {street2 ? <h1><b>Street2:</b> {street2}</h1> : <h1><b>Street2:</b> N/A</h1> }

                <h1 className='text-1xl font-bold' id="nfcd2">Address Details</h1>
                <div className="newformnames2">
                {city ? <h1><b>City:</b> {city}</h1>: <h1><b>City:</b> N/A</h1>}
                {state ? <h1 id="n2"><b>State:</b> {state}</h1> : <h1 id="n2"><b>State:</b> N/A</h1> }
                </div>
                <div className="newformnames2">
                {zip ? <h1><b>Zip Code:</b> {zip}</h1> : <h1><b>Zip Code:</b> N/A</h1> }
                {country ? <h1 id="n2"><b>Country:</b> {country}</h1>: <h1 id="n2"><b>Country:</b> N/A</h1> }    
                </div>
            </div>
        </div>
     );
}
 
export default NewClientDetailsList;